import { Injectable } from '@angular/core'
import { Action, Selector, State, StateContext, Store } from '@ngxs/store'
import { tap } from 'rxjs/operators'
import { ReportsService } from '../../reports.service'
import { SalesReportsStateModel } from './sales-reports.model'
import { GetSalesReports, GetLaborsReports } from './sales-reports.actions'
import { ShopFeatureType, ShopsState } from '@mg-platform/shops/shops-data-access'
import { MarketType } from '../../enums/market-type.enum'

@State<SalesReportsStateModel>({
  name: 'salesReports'
})
@Injectable()
export class SalesReportsState {
  constructor(
    private reportsService: ReportsService,
    private store: Store
  ) {}

  @Selector()
  static reports(state: SalesReportsStateModel) {
    return state.reports
  }

  @Selector()
  static laborsReports(state: SalesReportsStateModel) {
    return state.laborsReports
  }

  @Action(GetSalesReports)
  getSalesReports(ctx: StateContext<SalesReportsStateModel>, { payload }: GetSalesReports) {
    return this.reportsService.getSalesReports(payload).pipe(
      tap((res) => {
        ctx.patchState({ reports: res })
      })
    )
  }

  @Action(GetLaborsReports)
  getLaborsReports(ctx: StateContext<SalesReportsStateModel>, { payload }: GetLaborsReports) {
    const allShopsFeatures = this.store.selectSnapshot(ShopsState.allShopsFeatures)
    return this.reportsService.getLaborsReports(payload).pipe(
      tap((res) => {
        ctx.patchState({
          laborsReports: !res
            ? undefined
            : {
                ...res,
                laborSummaries: res.laborSummaries?.map((el) => ({
                  ...el,
                  noData:
                    el.marketType === MarketType.shop &&
                    !allShopsFeatures[el.id]?.includes(ShopFeatureType.Labor)
                }))
              }
        })
      })
    )
  }
}
